import {
  Component,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { UserBadgeService } from './user-badge.service';

@Component({
  selector: 'xs-user-badge',
  templateUrl: './user-badge.component.html',
  styleUrls: ['./user-badge.component.scss'],
})
export class UserBadgeComponent implements OnInit {
  @Input() userName: any;
  @Input() size: any;

  private _sizeClasses = {
    xs: 'badge-round-xs',
    sm: 'badge-round-sm',
    md: 'badge-round-md',
    lg: 'badge-round-lg',
  };

  constructor(private badgeService: UserBadgeService) {}

  ngOnInit() {}

  /** Returns the users initials */
  public initials = (): string => this.badgeService.getInitials(this.userName);

  /** Returns css class(es) representing the user */
  public cssClass = () => {
    let colorClass = 'badge-placeholder';
    if (this.userName) {
      const initials = this.initials();
      if (initials) {
        colorClass = this.badgeService.getXsightColorClass(initials);
      }
    }

    const value = this.getSizeClass() + ' ' + colorClass;
    return value;
  };

  private getSizeClass = (): string => {
    if (this.size && this.size in this._sizeClasses) {
      return this._sizeClasses[this.size] + this.getLanguageBasedFont();
    } else {
      return this._sizeClasses.md;
    }
  };

  private getLanguageBasedFont = (): string => {
    const regexJap =
      /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
    if (regexJap.test(this.initials())) {
      return ' jp';
    } else {
      return '';
    }
  };
}
